import Workspace from 'iam/models/Workspace'
import { observer } from 'mobx-react'
import React from 'react'
import SearchResultItem from 'components/inputs/CustomSelect/SearchResultItem'
import FormRow from 'components/inputs/FormRow'
import { ISchemaBoundValidationContext } from 'validx'
import WorkspaceSelectorViewModel from 'admin/bundle/WorkspaceSelectorForBundlesViewModel'
import {
  CustomSelect,
  SingleItemSelectedDefault,
  useCustomSelectStateFromInfiniteScrollProvider,
} from 'components/inputs/CustomSelect'
import { FormGroupContainer } from 'components/inputs'
import Avatar from 'components/Avatar'

export interface IWithWorkspaceSelectionForBundles {
  workspace?: Workspace
  workspaceSelectorVM: WorkspaceSelectorViewModel
  workspaceValidation: ISchemaBoundValidationContext<any>
  setWorkspace: (workspace?: Workspace) => void
}

interface Props {
  vm: IWithWorkspaceSelectionForBundles
  workspaceSelectorVM: WorkspaceSelectorViewModel
  isEditingBundleView?: boolean
  label?: string
}

export default observer(function BundleFormWorkspaceDropdown({
  vm,
  workspaceSelectorVM,
  isEditingBundleView = false,
  label,
}: Props) {
  const selectProps = useCustomSelectStateFromInfiniteScrollProvider({
    scrollProvider: workspaceSelectorVM.scrollProvider,
    searchText: workspaceSelectorVM.searchText,
    onSearchTextChange: workspaceSelectorVM.setSearchText,
    searchResults: workspaceSelectorVM.filteredWorkspaces,
  })

  return (
    <FormRow>
      <FormGroupContainer
        model={vm}
        field={'workspace'}
        label={
          label || (isEditingBundleView ? 'Workspace' : 'Select workspace')
        }
        error={vm.workspaceValidation.getError('workspace')}
      >
        <CustomSelect
          {...selectProps}
          placeholder={isEditingBundleView ? '' : 'Select workspace'}
          data-test="bundle-modal-workspace-dropdown"
          itemToString={(v) => String(v?.name)}
          value={vm.workspace}
          multi={false}
          onChange={vm.setWorkspace}
          renderItem={(itemProps) => (
            <SingleItemSelectedDefault
              {...itemProps}
              visual={
                <Avatar
                  size={24}
                  subject={{
                    displayName: itemProps.item.name,
                    avatar: itemProps.item.branding.logos.icon,
                  }}
                />
              }
            />
          )}
          renderSearchItem={({ item, itemToString, ...itemProps }) => (
            <SearchResultItem
              {...itemProps}
              data-test={'bundle-modal-workspace-' + item.name}
              visual={
                <Avatar
                  size={24}
                  subject={{
                    avatar: item.branding.logos.icon,
                    displayName: item.name,
                  }}
                />
              }
            >
              {item.name}
            </SearchResultItem>
          )}
          disabled={isEditingBundleView}
          icon={isEditingBundleView ? null : undefined}
        />
      </FormGroupContainer>
    </FormRow>
  )
})
